import React from 'react';
import '../../styles/pages.css';

const ShippingPage = () => {
  return (
    <div className="static-page">
      <h2 className="page-title">Política de Envio e Entrega</h2>

      <p>Na <strong>Gabrielly Semijoias</strong>, queremos que suas novas peças cheguem até você da forma mais rápida e segura possível. Veja abaixo como funciona nosso processo de envio.</p>

      <section>
        <h3>1. Formas de Envio</h3>
        <ul>
          <li>Trabalhamos com os <strong>Correios</strong> e diversas transportadoras parceiras (através da nossa integração com a plataforma <strong>Melhor Envio</strong>) para oferecer as melhores opções de custo e prazo para a sua localidade.</li>
          <li>As opções disponíveis (SEDEX, PAC, transportadora, etc.) serão exibidas no momento do cálculo do frete.</li>
        </ul>
      </section>

      <section>
        <h3>2. Cálculo do Frete</h3>
        <ul>
          <li>O valor do frete é calculado com base no peso e dimensões dos produtos, e no CEP de destino.</li>
          <li>Você pode simular o custo e o prazo de entrega de duas formas:
            <ol>
              <li>Na página do produto, inserindo seu CEP no campo "Calcular frete".</li>
              <li>No seu carrinho de compras, antes de finalizar o pedido.</li>
            </ol>
          </li>
          <li><strong>Frete Grátis:</strong> Oferecemos frete grátis para compras acima de um determinado valor. Consulte o banner no topo do site para ver a promoção vigente!</li>
        </ul>
      </section>

      <section>
        <h3>3. Prazo de Entrega</h3>
        <p>O prazo de entrega é a soma do nosso <strong>prazo de postagem</strong> e do <strong>prazo da transportadora</strong>.</p>
        <ul>
          <li><strong>Prazo de Postagem:</strong> Após a confirmação do pagamento, seu pedido será separado, embalado e postado em até <strong>2 dias úteis</strong>. Faremos o possível para enviar o quanto antes!</li>
          <li><strong>Prazo da Transportadora:</strong> Este é o tempo que a transportadora leva para entregar o pedido no seu endereço. Ele varia de acordo com a sua localidade e a modalidade de envio escolhida, sendo informado no momento do cálculo do frete.</li>
        </ul>
        <p>O prazo total (em dias úteis) começará a contar a partir da data de aprovação do pagamento.</p>
      </section>

      <section>
        <h3>4. Rastreamento do Pedido</h3>
        <ul>
          <li>Assim que seu pedido for postado, você receberá automaticamente um e-mail com o <strong>código de rastreamento</strong>.</li>
          <li>Com este código, você poderá acompanhar todas as etapas da sua entrega diretamente no site da transportadora correspondente.</li>
        </ul>
      </section>

      <section>
        <h3>5. Informações Importantes</h3>
        <ul>
          <li><strong>Endereço de Entrega:</strong> É de responsabilidade do cliente o preenchimento correto do endereço de entrega. Caso o pedido retorne para nós por endereço incorreto ou destinatário ausente, um novo frete será cobrado para o reenvio.</li>
          <li><strong>Recebimento:</strong> Certifique-se de que haverá alguém no local para receber o pedido. As transportadoras realizam, em geral, até três tentativas de entrega.</li>
          <li><strong>Atrasos:</strong> Embora raras, podem ocorrer falhas ou atrasos na entrega por parte da transportadora. Caso isso aconteça, entre em contato conosco imediatamente para que possamos abrir uma reclamação e solucionar o problema o mais rápido possível.</li>
        </ul>
      </section>

      <p>Se tiver qualquer outra dúvida, nossa equipe de atendimento está à disposição!</p>
    </div>
  );
};

export default ShippingPage;
